import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { IonIcon } from "@ionic/angular";
import { addIcons } from "ionicons";
import { closeOutline } from "ionicons/icons";

/**
 * The desktop dialog frame: a heading, an optional subtitle, a close control that is never the
 * primary action, the projected body, and an optional footer projected with `dialogFooter`.
 *
 * A modal component renders this inside its `@if (isDesktop)` branch and keeps its phone
 * toolbars in the `@else`; the call site adds `cssClass: "ff-modal"` so the sheet becomes a
 * content-sized dialog (see theme/desktop.scss). Width comes from `--ff-dialog-width`.
 */
@Component({
  selector: "app-dialog-shell",
  standalone: true,
  imports: [IonIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./dialog-shell.component.html",
  styleUrls: ["./dialog-shell.component.scss"],
})
export class DialogShellComponent {
  @Input() fullScreenOnMobile = false;
  @Input({ required: true }) title = "";
  @Input() subtitle = "";
  @Input() closeLabel = "Close";
  @Output() closeRequest = new EventEmitter<void>();

  constructor() {
    addIcons({ closeOutline });
  }
}
